<template>
  <el-dialog
    class="dialog-container"
    title="请选择"
    :visible.sync="dialogVisible"
    width="500px"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="国家" prop="countryDataId">
        <el-select
          filterable
          clearable
          v-model="form.countryDataId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="客户账号" prop="customer.customerAccountNum">
        <el-select
          filterable
          clearable
          v-model="form.customer.customerAccountNum"
          placeholder="请选择"
          style="width:100%"
          @change="customerAccountNumChange"
        >
          <el-option
            v-for="item in customerList"
            :key="item.customerAccountNum"
            :label="item.customerAccountNum"
            :value="item.customerAccountNum"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账户名称" required>
        <el-input disabled v-model="form.customer.customerName" />
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer-button">
      <el-button type="primary" @click="handleSave"> 确定 </el-button>
      <el-button plain @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSession, setStorageNew } from "@/util/localStor";
import { getKdScopeCountries } from "@/api/feedbackKD";
export default {
  components: {},
  props: {},
  data() {
    return {
      customerList: [], // 客户列表
      dialogVisible: false,
      form: {
        // customer: {}
      },
      countryList: [], // 国家列表（按当前用户 KD 角色权限范围）
      rules: {
        countryDataId: [{ required: true, message: "国家不能为空" }],
        // customer: {
        //   customerAccountNum: [{ required: true, message: "客户账号不能为空" }]
        // },
        // carType: [{ required: true, message: "反馈类型不能为空" }]
      },
    };
  },
  async mounted() {},
  methods: {
    // 初始化
    async init() {
      this.dialogVisible = true;
      try {
        const res = await getKdScopeCountries();
        this.countryList = res.data || [];
      } catch (e) {
        this.countryList = [];
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取选择客户
    customerAccountNumChange(customerAccountNum) {
      this.form.customer = {
        ...this.customerList.find(
          (item) => item.customerAccountNum === customerAccountNum
        ),
      };
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.$loading.show();
        setStorageNew("qualityData", this.form);
        this.$router.push({
          path: "/KDaddFeedback/detail",
          query: {
            operate: "add",
            // customer: JSON.stringify(this.form.customer)
          },
        });
        this.$loading.hide();
      });
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
